var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-inline",
      style: _vm.isExpand && {
        width: _vm.width ? _vm.width : "auto",
        maxWidth: _vm.maxWidth ? _vm.maxWidth : "auto"
      }
    },
    [
      _c(
        "div",
        [
          (_vm.file.type || "").includes("image")
            ? [
                !_vm.isExpand
                  ? _c(
                      "v-chip",
                      {
                        attrs: { dark: "", color: "info" },
                        on: { click: _vm.showImage }
                      },
                      [
                        _c("v-icon", { staticClass: "mr-1" }, [
                          _vm._v("image")
                        ]),
                        _vm._v(_vm._s(_vm.file.name))
                      ],
                      1
                    )
                  : _c(
                      "v-img",
                      _vm._b(
                        {
                          attrs: {
                            src: _vm.filePath,
                            "lazy-src": _vm.filePath,
                            contain: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "placeholder",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "fill-height": "",
                                          "align-center": "",
                                          "justify-center": "",
                                          "ma-0": ""
                                        }
                                      },
                                      [
                                        _c("v-progress-circular", {
                                          attrs: {
                                            indeterminate: "",
                                            color: "grey lighten-5"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1258913907
                          )
                        },
                        "v-img",
                        _vm.$attrs,
                        false
                      ),
                      [
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            attrs: { "pa-1": "", column: "", "fill-height": "" }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { "text-xs-right": "" } },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    staticStyle: {
                                                      "background-color":
                                                        "rgba(0, 0, 0, .2)"
                                                    },
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.isExpand = false
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "white" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "keyboard_arrow_up"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      715023959
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("closeThisImage")))
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { shrink: "", "text-xs-right": "" } },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    staticStyle: {
                                                      "background-color":
                                                        "rgba(0, 0, 0, .2)"
                                                    },
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.link()
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "white",
                                                        flat: ""
                                                      }
                                                    },
                                                    [_vm._v("zoom_in")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4068751799
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("openInBewTab")))
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    staticStyle: {
                                                      "background-color":
                                                        "rgba(0, 0, 0, .2)"
                                                    },
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.download()
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "white",
                                                        flat: ""
                                                      }
                                                    },
                                                    [_vm._v("save_alt")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3612852107
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("saveThisImage")))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
              ]
            : (_vm.file.type || "").includes("video/mp4")
            ? [
                !_vm.isExpand
                  ? _c(
                      "v-chip",
                      {
                        attrs: { dark: "", color: "info" },
                        on: { click: _vm.showImage }
                      },
                      [
                        _c("v-icon", { staticClass: "mr-1" }, [
                          _vm._v("image")
                        ]),
                        _vm._v(_vm._s(_vm.file.name))
                      ],
                      1
                    )
                  : _c(
                      "video",
                      { attrs: { width: "480", controls: "", autoplay: "" } },
                      [
                        _c("source", {
                          attrs: { src: _vm.filePath, type: "video/mp4" }
                        }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("notSupportVideo")) +
                            "\n      "
                        )
                      ]
                    )
              ]
            : (_vm.file.type || "").includes("application/pdf")
            ? [
                !_vm.isExpand
                  ? _c(
                      "v-chip",
                      {
                        attrs: { dark: "", color: "info" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.download.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.showImage.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("remove_red_eye")]
                        ),
                        _vm._v(" " + _vm._s(_vm.file.name))
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "text-xs-right" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticStyle: {
                              "background-color": "rgba(0, 0, 0, .2)"
                            },
                            attrs: { icon: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.isExpand = false
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "white" } }, [
                              _vm._v("keyboard_arrow_up")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("embed", {
                          attrs: {
                            src: _vm.filePath,
                            type: "application/pdf",
                            width: "100%",
                            height: "600px"
                          }
                        })
                      ],
                      1
                    )
              ]
            : _c(
                "v-chip",
                {
                  attrs: { dark: "", color: "info" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.download.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("attachment")]),
                  _vm._v(_vm._s(_vm.file.name))
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("div", { staticClass: "text-xs-center red--text" }, [
            _vm._v(_vm._s(_vm.errorMessage))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c9148f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c9148f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FsFileChip.vue
// module id = null
// module chunks = 